import { render, staticRenderFns } from "./MassComs.vue?vue&type=template&id=7e205c16&scoped=true&"
import script from "./MassComs.vue?vue&type=script&lang=js&"
export * from "./MassComs.vue?vue&type=script&lang=js&"
import style0 from "./MassComs.vue?vue&type=style&index=0&id=7e205c16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e205c16",
  null
  
)

export default component.exports